import { Component } from 'react'

class MultiSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
      <label htmlFor={this.props.id}>
        <input
          type="checkbox"
          defaultChecked={false}
          checked={this.props.checked}
          onChange={this.props.onChange}
          className="swp-multi-select-checkbox"
          name={this.props.name}
          id={this.props.id}
          aria-labelledby="multi-select1-text"
        />
        <div className="swp-multi-select">
          <div className="swp-multi-select__text" id="multi-select1-text">
            {this.props.textValue}
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 24 24"
          >
            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z"></path>
          </svg>
        </div>
      </label>
    )
  }
}
export default MultiSelect
